import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLaceUpShoes = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1436_1157)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M20.8847 8.4351C20.8275 8.20475 20.6249 8.03337 20.3768 8.00517C20.1309 7.9722 19.8889 8.09965 19.7761 8.31022C19.7683 8.3245 18.9983 9.74211 17.7405 10.086C17.1583 10.2468 16.5653 10.1519 15.9229 9.8018L14.195 8.1652C14.014 7.99345 13.7372 7.95133 13.5099 8.05974L6.45958 11.3992C5.83915 11.5146 2.4939 12.2517 2.4939 14.7504V16.4379C2.4939 16.7484 2.75985 17.0004 3.08765 17.0004H20.9002C21.2279 17.0004 21.4939 16.7484 21.4939 16.4379V14.7504L21.4935 14.7487C21.5985 12.6262 21.3942 10.5022 20.8847 8.4351ZM6.74872 12.4927C6.80631 12.4832 6.86314 12.466 6.91571 12.4411L9.30381 11.3098L10.3866 12.3356C10.5026 12.4455 10.6545 12.5004 10.8064 12.5004C10.9583 12.5004 11.1102 12.4455 11.2262 12.3356C11.4581 12.1159 11.4581 11.7599 11.2262 11.5402L10.4232 10.7795L11.2829 10.3723L12.7616 11.7731C12.8776 11.883 13.0291 11.9379 13.1814 11.9379C13.3337 11.9379 13.4852 11.883 13.6012 11.7731C13.8331 11.5534 13.8331 11.1974 13.6012 10.9777L12.4024 9.84198L13.6576 9.24735L15.1366 10.6481C15.1706 10.6807 15.2093 10.7089 15.251 10.7327C16.2035 11.274 17.1544 11.4197 18.0768 11.1648C18.8931 10.94 19.5371 10.4342 19.9972 9.94901C20.252 11.3473 20.3541 12.7669 20.3188 14.1879H3.80002C4.35536 12.895 6.72142 12.4969 6.74872 12.4927ZM20.3064 15.8754H3.6814V15.3129H20.3064V15.8754Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1436_1157",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 19,
			height: 9,
			fill: "white",
			transform: "translate(2.5 8)"
		})
	}) })]
});
export default SvgLaceUpShoes;
